import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import IntelligentQuiz from './components/IntelligentQuiz';
import PlanPage from './components/PlanPage';
import AdminEmbedPage from './components/AdminEmbedPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/quiz" element={<IntelligentQuiz />} />
          <Route path="/plan" element={<PlanPage />} />
          <Route path="/admin" element={<AdminEmbedPage />} />
        </Routes>
        
        {/* Emergent Badge - Temporary removed to fix render issue */}
      </div>
    </Router>
  );
}

export default App;